import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import AppsPriceFilter from "../../components/filters/AppsPriceFilter/AppsPriceFilter";
import AppsPriceFilterResult from "../../components/filters/AppsPriceFilter/AppsPriceFilterResult";
import type { IAppsFilterOptionsDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindAppsPriceFilter from "./PriceFilter";

const createPriceFilter = (description: IAppsFilterOptionsDto): SearchFilterInstance => ({
    key: "price",
    trackingName: "App Price",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.price.title" },
    tooltipText: { key: "si.find_apps.filters.price.tooltip" },
    filter: new FindAppsPriceFilter({
        options: description.priceFilter,
    }),
    filterView: AppsPriceFilter,
    filterResultView: AppsPriceFilterResult,
});

export default createPriceFilter;
